import { render, staticRenderFns } from "./IotSetup.vue?vue&type=template&id=5481aeb2"
import script from "./IotSetup.vue?vue&type=script&lang=js"
export * from "./IotSetup.vue?vue&type=script&lang=js"
import style0 from "./IotSetup.vue?vue&type=style&index=0&id=5481aeb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports